import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import baseTheme from "@insite/mobius/globals/baseTheme";
import Page from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import * as React from "react";
import { css } from "styled-components";

const homePageStyles = {
    css: css`
    margin: auto;
    ${({ theme }) => {
        const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
        return breakpointMediaQueries(theme, [
            css`
            padding-left: 15px;
            padding-right: 15px;
            max-width: ${maxWidths[0]}px;
        `,
            css`
            padding-left: 15px;
            padding-right: 15px;
            max-width: ${maxWidths[1]}px;
        `,
            css`
            padding-left: 15px;
            padding-right: 15px;
            max-width: ${maxWidths[2]}px;
        `,
            css` 
            padding-left: 60px;
            padding-right: 60px;
            max-width: ${maxWidths[3]}px;`,
            css`
            padding-left: 60px;
            padding-right: 60px;
            max-width: ${maxWidths[4]}px;`,
        ]);
    }}
    `,
}

const HomePage: React.FunctionComponent<PageProps> = ({ id }: PageProps) => (
    <Page data-test-selector="homePage" style={{ padding: 0, background: "none", maxWidth: "none" }}>
        <StyledWrapper style={{ paddingBottom: "15px", width: "100%" }}>
            <Zone contentId={id} zoneName="FullWidthContent" />
        </StyledWrapper>
        <StyledWrapper {...homePageStyles}>
            <Zone contentId={id} zoneName="Content" requireRows />
        </StyledWrapper>
        <StyledWrapper style={{ paddingBottom: "15px", width: "100%", background: "#f1efef"}}>
            <Zone contentId={id} zoneName="FullWidthContent2" />
        </StyledWrapper>
        <AddToListModal />
    </Page>
);

const pageModule: PageModule = {
    component: HomePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
    },
};

export default pageModule;

export const HomePageContext = "HomePage";
